/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Hero_SubtitleInputs */

const en_fw_hero_subtitle = /** @type {(inputs: Fw_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where to watch the Firefly Wedding anime, every episode date, the story, the cast and the latest news.`)
};

const zh_fw_hero_subtitle = /** @type {(inputs: Fw_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画在哪看、每一话何时播出、剧情、角色声优与最新消息，都在这里。`)
};

/**
* | output |
* | --- |
* | "Where to watch the Firefly Wedding anime, every episode date, the story, the cast and the latest news." |
*
* @param {Fw_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_hero_subtitle = /** @type {((inputs?: Fw_Hero_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Hero_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_hero_subtitle(inputs)
	return zh_fw_hero_subtitle(inputs)
});
export { fw_hero_subtitle as "fw.hero.subtitle" }